<div class="card-info-container">
  <div class="header-row">
    <div>
      <span class="emoji" [innerHTML]="card?.emoji"></span>
      <span class="title">{{ card?.title }}</span>
    </div>
    <span class="badge" [ngClass]="card?.badge?.level">
      {{ card?.badge?.text }}
    </span>
  </div>
  <div class="labels-row">
    <div *ngFor="let item of card?.labels">
      <span class="value">{{ item.value }}</span>
      <span class="description">{{ item.txt }}</span>
    </div>
  </div>
  <div *ngIf="card?.scoreInfo" class="score-section">
    <div class="stars-row">
      <p-rating [ngModel]="card?.scoreInfo?.score" [disabled]="true"></p-rating>
      <span class="score">{{ card?.scoreInfo?.score }}/5.0</span>
    </div>
    @if (card?.scoreInfo?.colorCircle) {
      <div class="score-info-row">
        <span class="color-circle" [style.backgroundColor]="card?.scoreInfo?.colorCircle"></span>
        <span class="txt">{{ card?.scoreInfo?.txt }}</span>
      </div>
    }
  </div>
  <div class="lists-section">
    <span>{{ card?.lists?.title }}</span>
    <ul>
      <li *ngFor="let item of card?.lists?.items">{{ item }}</li>
    </ul>
  </div>
</div>